/**
 * Requires
 */

import svg4everybody from 'svg4everybody'

/**
 * Initialisation
 */

export function initialise() {
  svg4everybody()
}
